(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evenform-reference"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('evenform-reference')) {
  customElements.define('evenform-reference', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) this.showSlide(thumb.dataset.thumb);
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow) {
          const slides = [...this.querySelectorAll('[data-slide]')];
          const active = slides.findIndex(slide => !slide.hidden);
          this.showSlide((active + Number(arrow.dataset.galleryStep) + slides.length) % slides.length);
        }
        if (event.target.closest('[data-one-time]')) {
          const plan = this.querySelector('[data-plan-select]');
          if (plan && [...plan.options].some(option => option.value === '')) {
            plan.value = '';
            this.updatePrice();
            this.querySelector('[data-add-button]').focus();
          }
        }
      }, options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-variant-input]')) this.changeVariant();
        if (event.target.matches('[data-plan-select]')) this.updatePrice();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const slide = event.target.closest('[data-slide]');
        if (slide) this.showSlide(slide.dataset.slide);
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      }, options);
      this.updatePrice(false);
    }
    disconnectedCallback() { this.abort?.abort(); }
    showSlide(index) {
      this.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== String(index); });
      this.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.thumb === String(index))));
    }
    get variant() {
      const id = this.querySelector('[data-variant-input]')?.value;
      return this.querySelector(`template[data-variant-template="${id}"]`);
    }
    changeVariant() {
      const variant = this.variant;
      if (!variant) return;
      const oldPlan = this.querySelector('[data-plan-select]')?.value;
      this.querySelector('[data-plan-host]').replaceChildren(variant.content.cloneNode(true));
      const plan = this.querySelector('[data-plan-select]');
      if (plan && [...plan.options].some(option => option.value === oldPlan)) plan.value = oldPlan;
      const qty = this.querySelector('[name="quantity"]');
      qty.min = variant.dataset.min;
      qty.step = variant.dataset.step;
      if (variant.dataset.max) qty.max = variant.dataset.max; else qty.removeAttribute('max');
      qty.value = variant.dataset.min;
      const available = variant.dataset.available === 'true';
      this.querySelector('[data-add-button]').disabled = !available;
      this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
      this.querySelector('[data-stock]').textContent = available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
      const slide = this.querySelector(`[data-slide][data-image-id="${variant.dataset.imageId}"]`);
      if (slide) this.showSlide(slide.dataset.slide);
      this.updatePrice();
    }
    updatePrice(updateUrl = true) {
      const variant = this.variant;
      if (!variant) return;
      const plan = this.querySelector('[data-plan-select]');
      const option = plan?.selectedOptions[0];
      this.querySelector('[data-current-price]').textContent = option?.dataset.price || variant.dataset.price;
      const compare = option ? option.dataset.compare : variant.dataset.compare;
      const compareNode = this.querySelector('[data-compare-price]');
      compareNode.textContent = compare || '';
      compareNode.hidden = !compare;
      this.querySelectorAll('[data-plan-terms]').forEach(node => { node.hidden = node.dataset.planTerms !== plan?.value; });
      this.querySelectorAll('[data-subscription-note]').forEach(node => { node.hidden = !plan?.value; });
      const oneTime = this.querySelector('[data-one-time]');
      if (oneTime) oneTime.hidden = !plan?.value || ![...plan.options].some(option => option.value === '');
      if (updateUrl && this.dataset.productUrl && !(window.Shopify && Shopify.designMode)) {
        const url = new URL(window.location.href);
        const productPath = new URL(this.dataset.productUrl, window.location.origin).pathname;
        if (url.pathname === productPath) {
          url.searchParams.set('variant', variant.dataset.variantTemplate);
          if (plan?.value) url.searchParams.set('selling_plan', plan.value); else url.searchParams.delete('selling_plan');
          window.history.replaceState({}, '', url);
        }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evenform-smooche-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('evenform-comments')) {
    customElements.define('evenform-comments', class extends HTMLElement {
      connectedCallback() {
        if (this.onCommentClick) return;
        this.track = this.querySelector('.ef-comment-track');
        const count = this.track.children.length;
        this.hidden = count === 0;
        this.querySelector('.ef-comment-controls').hidden = count < 2;
        const position = () => Math.max(0, Math.min(count - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
        this.onCommentScroll = () => {
          this.querySelector('[data-comment-position]').textContent = (position() + 1) + ' / ' + count;
        };
        this.onCommentClick = event => {
          const button = event.target.closest('[data-comment-step]');
          if (!button || count < 2) return;
          const next = (position() + Number(button.dataset.commentStep) + count) % count;
          this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'auto' });
        };
        this.addEventListener('click', this.onCommentClick);
        this.track.addEventListener('scroll', this.onCommentScroll, { passive: true });
        this.onCommentScroll();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onCommentClick);
        this.track?.removeEventListener('scroll', this.onCommentScroll);
        this.onCommentClick = null;
      }
    });
  }

  if (!customElements.get('evenform-gallery')) {
    customElements.define('evenform-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.onGalleryClick) return;
        this.onGalleryClick = event => {
          const thumbs = Array.from(this.querySelectorAll('[data-ef-thumb]'));
          const arrow = event.target.closest('[data-step]');
          let thumb = event.target.closest('[data-ef-thumb]');
          if (arrow && this.contains(arrow) && thumbs.length > 1) {
            const current = Math.max(0, thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
            thumb = thumbs[(current + Number(arrow.dataset.step) + thumbs.length) % thumbs.length];
          }
          const main = this.querySelector('[data-ef-main-image]');
          if (!thumb || !this.contains(thumb) || !main) return;
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt || '';
          main.width = Number(thumb.dataset.width);
          main.height = Number(thumb.dataset.height);
          this.querySelectorAll('[data-ef-thumb]').forEach(button => {
            button.classList.toggle('is-active', button === thumb);
            button.setAttribute('aria-pressed', String(button === thumb));
          });
        };
        this.addEventListener('click', this.onGalleryClick);
        this.onSwipeStart = event => {
          this.swipeStart = event.touches.length === 1 && event.target.closest('.ef-main-media') && !event.target.closest('button')
            ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        };
        this.onSwipeEnd = event => {
          const start = this.swipeStart;
          this.swipeStart = null;
          if (!start || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.querySelector('[data-step="' + (dx < 0 ? '1' : '-1') + '"]')?.click();
          }
        };
        this.onSwipeCancel = () => { this.swipeStart = null; };
        this.addEventListener('touchstart', this.onSwipeStart, { passive: true });
        this.addEventListener('touchend', this.onSwipeEnd, { passive: true });
        this.addEventListener('touchcancel', this.onSwipeCancel, { passive: true });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onGalleryClick);
        this.removeEventListener('touchstart', this.onSwipeStart);
        this.removeEventListener('touchend', this.onSwipeEnd);
        this.removeEventListener('touchcancel', this.onSwipeCancel);
        this.swipeStart = null;
        this.onGalleryClick = null;
      }
    });
  }

  if (!customElements.get('evenform-countdown')) {
    customElements.define('evenform-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        const raw = this.getAttribute('duration') || '';
        const match = raw.trim().match(/^(\d{1,4}):([0-5]\d):([0-5]\d)$/);
        if (!match) { this.textContent = '—'; return; }
        const seconds = Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3]);
        const key = 'evenform-countdown-v1:' + location.pathname + ':' + this.getAttribute('storage-key') + ':' + raw;
        let deadline = Date.now() + seconds * 1000;
        try {
          const saved = localStorage.getItem(key);
          if (saved !== null && Number.isFinite(Number(saved)) && Number(saved) > 0) deadline = Number(saved);
          else localStorage.setItem(key, String(deadline));
        } catch (error) {}
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          this.textContent = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
          if (remaining === 0) { clearInterval(this.timer); this.setAttribute('aria-label', 'Countdown ended'); }
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
